import { useEffect } from "react";

export function usePopulateItems({
  typeOfProperty,
  typeOfTemplate,
  items,
  columns,
  shop,
  rideItems,
  setColumns,
  addSetItemsCount,
}) {
  useEffect(() => {
    if (typeOfProperty && typeOfTemplate && items) {
      const newColumns = columns.map((column) => {
        return column
          .map((item) => {
            const isShop = item && item.type === "shop";
            if (!shop && isShop) {
              return null;
            }
            return item;
          })
          .filter((e) => e);
      });

      const ride = rideItems;

      setColumns(newColumns);

      addSetItemsCount({ ride, newColumns });
    }
    // Intentionally only re-filters shop items when the shop toggle changes.
    // Including columns/items/rideItems/addSetItemsCount (recreated each render)
    // would re-run on every data change and re-filter columns, changing behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shop]);
}
